var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as TYPES from "./types";
import * as widgetService from '../../services/widget-service';
import { multiAction } from '../../utils/ReduxUtil';
export var getTemplatePublisherInit = function () { return ({ type: TYPES.GET_TEMPLATE_PUBLISHER_INIT }); };
export var getTemplatePublisherSuccess = function (data) { return ({ type: TYPES.GET_TEMPLATE_PUBLISHER_SUCCES, data: data }); };
export var getTemplatePublisherError = function (error) { return ({ type: TYPES.GET_TEMPLATE_PUBLISHER_ERROR, error: error }); };
export var getTemplatePublisherDone = function () { return ({ type: TYPES.GET_TEMPLATE_PUBLISHER_DONE }); };
export var getTemplatePublisher = function (data) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getTemplatePublisherInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getTemplateByPublisher(data)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getTemplatePublisherSuccess(result), getTemplatePublisherDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch(multiAction([getTemplatePublisherError(error_1), getTemplatePublisherDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getTemplateUserInit = function () { return ({ type: TYPES.GET_TEMPLATE_USER_INIT }); };
export var getTemplateUserSuccess = function (data) { return ({ type: TYPES.GET_TEMPLATE_USER_SUCCES, data: data }); };
export var getTemplateUserError = function (error) { return ({ type: TYPES.GET_TEMPLATE_USER_ERROR, error: error }); };
export var getTemplateUserDone = function () { return ({ type: TYPES.GET_TEMPLATE_USER_DONE }); };
export var getTemplateUser = function (data) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getTemplateUserInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getTemplateByUser(data)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getTemplateUserSuccess(result), getTemplateUserDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    dispatch(multiAction([getTemplateUserError(error_2), getTemplateUserDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateTemplateInit = function () { return ({ type: TYPES.UPDATE_TEMPLATE_INIT }); };
export var updateTemplateSuccess = function (data) { return ({ type: TYPES.UPDATE_TEMPLATE_SUCCES, data: data }); };
export var updateTemplateError = function (error) { return ({ type: TYPES.UPDATE_TEMPLATE_ERROR, error: error }); };
export var updateTemplateDone = function () { return ({ type: TYPES.UPDATE_TEMPLATE_DONE }); };
export var updateTemplate = function (data) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(updateTemplateInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.updateDefaultTemplate(data)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([updateTemplateSuccess(result), updateTemplateDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    dispatch(multiAction([updateTemplateError(error_3), updateTemplateDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateUserTemplateInit = function () { return ({ type: TYPES.UPDATE_USER_TEMPLATE_INIT }); };
export var updateUserTemplateSuccess = function (data) { return ({ type: TYPES.UPDATE_USER_TEMPLATE_SUCCES, data: data }); };
export var updateUserTemplateError = function (error) { return ({ type: TYPES.UPDATE_USER_TEMPLATE_ERROR, error: error }); };
export var updateUserTemplateDone = function () { return ({ type: TYPES.UPDATE_USER_TEMPLATE_DONE }); };
export var updateUserTemplate = function (data) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(updateUserTemplateInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.updateUserTemplate(data)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([updateUserTemplateSuccess(result), updateUserTemplateDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    dispatch(multiAction([updateUserTemplateError(error_4), updateUserTemplateDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getWidgetInit = function () { return ({ type: TYPES.GET_WIDGET_LIST_INIT }); };
export var getWidgetSuccess = function (data) { return ({ type: TYPES.GET_WIDGET_LIST_SUCCESS, data: data }); };
export var getWidgetError = function (error) { return ({ type: TYPES.GET_WIDGET_LIST_ERROR, error: error }); };
export var getWidgetDone = function () { return ({ type: TYPES.GET_WIDGET_LIST_DONE }); };
export var getWidgets = function (param) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getWidgetInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getWidgets(param)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getWidgetSuccess(result), getWidgetDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    dispatch(multiAction([getWidgetError(error_5), getWidgetDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getMediaInit = function () { return ({ type: TYPES.GET_MEDIA_LIST_INIT }); };
export var getMediaSuccess = function (data) { return ({ type: TYPES.GET_MEDIA_LIST_SUCCESS, data: data }); };
export var getMediaError = function (error) { return ({ type: TYPES.GET_MEDIA_LIST_ERROR, error: error }); };
export var getMediaDone = function () { return ({ type: TYPES.GET_MEDIA_LIST_DONE }); };
export var getMedias = function (params) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getMediaInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getMedias(params)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getMediaSuccess(result), getMediaDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _a.sent();
                    dispatch(multiAction([getMediaError(error_6), getMediaDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getWidgetDetailsInit = function () { return ({ type: TYPES.GET_WIDGET_DETAILS_INIT }); };
export var getWidgetDetailsSuccess = function (data) { return ({ type: TYPES.GET_WIDGET_DETAILS_SUCCESS, data: data }); };
export var getWidgetDetailsError = function (error) { return ({ type: TYPES.GET_WIDGET_DETAILS_ERROR, error: error }); };
export var getWidgetDetailsDone = function () { return ({ type: TYPES.GET_WIDGET_DETAILS_DONE }); };
export var getWidgetDetails = function (widgetCode) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getWidgetDetailsInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getWidgetDetails(widgetCode)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getWidgetDetailsSuccess(result), getWidgetDetailsDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_7 = _a.sent();
                    dispatch(multiAction([getWidgetDetailsError(error_7), getWidgetDetailsDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getWidgetCalendarInit = function () { return ({ type: TYPES.GET_WIDGET_CALENDAR_INIT }); };
export var getWidgetCalendarSuccess = function (data) { return ({ type: TYPES.GET_WIDGET_CALENDAR_SUCCESS, data: data }); };
export var getWidgetCalendarError = function (error) { return ({ type: TYPES.GET_WIDGET_CALENDAR_ERROR, error: error }); };
export var getWidgetCalendarDone = function () { return ({ type: TYPES.GET_WIDGET_CALENDAR_DONE }); };
export var getWidgetCalendar = function (param) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getWidgetCalendarInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getWidgetCalendar(param)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getWidgetCalendarSuccess(result), getWidgetCalendarDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_8 = _a.sent();
                    dispatch(multiAction([getWidgetCalendarError(error_8), getWidgetCalendarDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getWidgetDataOriginInit = function () { return ({ type: TYPES.GET_WIDGET_DATA_INIT }); };
export var getWidgetDataOriginSuccess = function (data) { return ({ type: TYPES.GET_WIDGET_DATA_SUCCESS, data: data }); };
export var getWidgetDataOriginError = function (error) { return ({ type: TYPES.GET_WIDGET_DATA_ERROR, error: error }); };
export var getWidgetDataOriginDone = function () { return ({ type: TYPES.GET_WIDGET_DATA_DONE }); };
export var getWidgetDataOrigin = function (param) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getWidgetDataOriginInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, widgetService.getWidgetCalendar(param)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([getWidgetDataOriginSuccess(result), getWidgetDataOriginDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    error_9 = _a.sent();
                    dispatch(multiAction([getWidgetDataOriginError(error_9), getWidgetDataOriginDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var storeCacheWidgetSummaryAction = function (watchLogOut) { return ({ type: TYPES.LOADING_INTERVAL_WD_SUMARY, watchLogOut: watchLogOut }); };
export var storeCacheWidgetSummary = function (watchLogOut) {
    return function (dispatch) {
        dispatch(storeCacheWidgetSummaryAction(watchLogOut));
    };
};
export var storeCacheWidgetTop3RateActionIncrease = function (watchLogOut) { return ({ type: TYPES.LOADING_INTERVAL_WD_TOP3_RATE_INCREASE, watchLogOut: watchLogOut }); };
export var storeCacheWidgetTop3RateIncrease = function (watchLogOut) {
    return function (dispatch) {
        dispatch(storeCacheWidgetTop3RateActionIncrease(watchLogOut));
    };
};
export var storeCacheWidgetTop3RateActionDecrease = function (watchLogOut) { return ({ type: TYPES.LOADING_INTERVAL_WD_TOP3_RATE_DECREASE, watchLogOut: watchLogOut }); };
export var storeCacheWidgetTop3RateDecrease = function (watchLogOut) {
    return function (dispatch) {
        dispatch(storeCacheWidgetTop3RateActionDecrease(watchLogOut));
    };
};
export var resetDefaultTemplate = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(getTemplatePublisherSuccess(null));
            dispatch(getTemplatePublisherError(null));
            return [2 /*return*/];
        });
    }); };
};
export var resetUserTemplate = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(getTemplateUserSuccess(null));
            dispatch(getTemplateUserError(null));
            return [2 /*return*/];
        });
    }); };
};
export var resetMediaInfo = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(getMediaSuccess(null));
            dispatch(getMediaError(null));
            return [2 /*return*/];
        });
    }); };
};
